import * as types from '../mutation-types'
import { updateObjVal} from '@/utils/util'
const state = {
  riskObj: {  // 风控信息
    isShow: false,   // 风控弹窗展示
    type: 0,        // 风控类型 返回结果后续操作: 0无操作;1提示;2累计风控积分;3短信验证码;4人脸识别;5拒绝访问;
    message: '',     // 风控信息
    modelGuid: '', // 验证码需要
    userVerifyRecordId: '', // 人脸核身需要
    resolvePaths: [] // router 对象 json string，确保使用 router name 人脸核身后跳转路径[success | default, failed]
  }
}

const getters = {
  riskObj: state => state.riskObj
}

const mutations = {
  [types.RISK_OBJ](state, {value, key}) {
    state = updateObjVal(state, key, value)
  }
}

const actions = {
  // 显示风险
  setRiskObj({ commit }, { value, key = 'riskObj' } = {}) {
    commit(types.RISK_OBJ, {value, key})
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
